import {
  publishEventParameter,
  publishEventParameterGA,
  publishEvents,
} from '@porterin/component-library/src/ts-utils/analytics/react-ga/EventTracker';

import { CategoryType } from '../configs/CategoryTypes';
import {
  addParamsToUrl,
  queryMapper,
  getURLParams,
  getUtmKeyValues,
  geoRegionIdToCity,
  validateNumber,
  getGtesUnregisteredPayload,
  getFareEstimateFormPayload,
} from '../configs/Config';
import {
  ga_fare_estimate_successful,
  form_submit_ga_event_prefix,
} from '../configs/Store.store';
import {
  FareEstimateResultQueryParams,
  FareEstimateFormParameter,
  RequirementValue,
  Labels,
  RequirementOption,
} from '../types/HelperTypes';

export const submitButtonGaEvent = (
  category: string,
  requirement: CategoryType,
): string => {
  switch (requirement) {
    case CategoryType.TwoWheelers:
      return (
        form_submit_ga_event_prefix +
        (category === 'Home' ? category + ' 2W' : '2 wheeler')
      );
    case CategoryType.Trucks:
      return (
        form_submit_ga_event_prefix +
        (category === 'Home' ? category + ' Trucks' : 'trucks')
      );
    case CategoryType.Partload:
      return (
        form_submit_ga_event_prefix +
        (category === 'Home' ? category + ' Partload' : 'partload')
      );
    default:
      return form_submit_ga_event_prefix + category;
  }
};

export const publishGtesEvent = (
  category: string,
  payload: FareEstimateFormParameter,
): void => {
  publishEvents(
    category,
    ga_fare_estimate_successful,
    `1_${payload.name}#2_${payload.mobile}#3_frequency-${payload.frequency}#4_${payload.utm_source}#5_${payload.utm_campaign}#6_${payload.service_category}`,
  );
};

export const publishGtesUnregisteredEvent = (
  payload: FareEstimateFormParameter,
): void => {
  publishEventParameterGA(
    'GTES_Unregistered',
    getGtesUnregisteredPayload(payload),
  );
};

export const publishFareEstimateSuccessfulEventParameter = (
  params: FareEstimateFormParameter,
): void => {
  publishEventParameter(
    'GTES Event Paramenter',
    getFareEstimateFormPayload(params),
  );
};

export const fireUnregEventIfCustNotExist = (
  parameters: FareEstimateFormParameter,
  send_unregistered_event_flag: boolean,
): void => {
  if (send_unregistered_event_flag) {
    publishGtesUnregisteredEvent(parameters);
  }
};

export const getFareEstimateFormParameter = (
  queryParams: FareEstimateResultQueryParams,
): FareEstimateFormParameter => {
  return {
    name: queryParams?.customer_name || '',
    mobile: queryParams?.customer_mobile || '',
    service_category: queryParams?.service_category || '',
    user_city:
      queryParams?.geo_region_id && validateNumber(queryParams?.geo_region_id)
        ? geoRegionIdToCity(parseInt(queryParams?.geo_region_id))
        : undefined,
    frequency: queryParams?.frequency || '',
    utm_source: queryParams?.utm_source || '',
    utm_campaign: queryParams?.utm_campaign || '',
  };
};

export const fireGTEEventsOnLeadCreated = (
  redirect_url: string,
  service_category: string,
  category: string,
  source: string,
  send_unregistered_event_flag: boolean,
): void => {
  const params: [string, string][] = getUtmKeyValues(source);
  params.push(['service_category', service_category]);
  const fare_estimate_parameters: FareEstimateFormParameter =
    getFareEstimateFormParameter(
      queryMapper(getURLParams(addParamsToUrl(redirect_url, params))),
    );
  publishFareEstimateSuccessfulEventParameter(fare_estimate_parameters);
  publishGtesEvent(category, fare_estimate_parameters);
  fireUnregEventIfCustNotExist(
    fare_estimate_parameters,
    send_unregistered_event_flag,
  );
};

export const getRequirementRadioOptions = (
  requirementValue: RequirementValue | undefined,
  labels: Labels,
): RequirementOption[] => [
  {
    checked: requirementValue === 'business',
    disabled: false,
    identifiers: { id: 'business' },
    label: labels.business,
    value: 'business',
    className: '',
  },
  {
    checked: requirementValue === 'personal',
    disabled: false,
    identifiers: { id: 'personal' },
    label: labels.personal,
    value: 'personal',
    className: '',
  },
];
